import { useMutation } from '@tanstack/react-query';
import { beginDesktopSignIn } from 'shared/services/backend-api';

// A mutation, not a query: every call parks a fresh single-use code, so a cached result would hand back a spent one.
export const useBeginDesktopSignInMutation = () =>
  useMutation<string, Error, string>({
    mutationFn: (challenge: string) => beginDesktopSignIn(challenge),
  });
